//
//
//
//
//
//
//
//
//
//
//
//

import QfMIcons from "./qf-m-icons";

export default {
    name: "QfPIcons",
    components: { QfMIcons },
    props: ["value", "disable"],
    data() {
        return {
            localValue: null,
            showModal: false,
            actions: [
                { icon: "mdi-file-find-outline", handler: () => { this.openModel(); } },
                { icon: "mdi-close-circle", content: true, handler: () => { this.clearValue(); } }
            ]
        };
    },
    watch: {
        value: {
            handler(value) {
                this.localValue = value;
            },
            immediate: true
        },
        localValue(val) {
            this.$emit("input", val);
        }
    },
    methods: {
        openModel() {
            this.showModal = true;
        },
        clearValue() {
            this.onUpdate(null);
        },
        onUpdate(newValue) {
            this.localValue = newValue;
            // this.$emit("input", newValue);
        }
    }
};
